import { render, staticRenderFns } from "./ScreenDisplayUi.vue?vue&type=template&id=437456a2&scoped=true&"
import script from "./ScreenDisplayUi.vue?vue&type=script&lang=js&"
export * from "./ScreenDisplayUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437456a2",
  null
  
)

export default component.exports